const aboveGridConfig = [
    {
        name: 'image',
    },
    {
        name: 'title',
    },
    {
        name: 'productPageLink',
    },
    {
        name: 'price',
    },
    {
        name: 'ratings',
    },
    {
        name: 'color',
    },
    {
        name: 'modelNumber',
    },
];

export default aboveGridConfig;
